import React from "react";
import { Helmet } from "react-helmet-async";
import { useSiteSettings } from "../../lib/settings";
import { resolveImage } from "../admin/ImageUpload";

/**
 * Global site meta: sets the browser tab default title, title template and
 * favicon based on the SiteSettings document. Placed once at the top of the
 * router tree so every route (public + admin) picks these up.
 *
 * Individual pages can still override with a deeper <Seo> / <Helmet><title>.
 */
const SiteMeta = () => {
  const s = useSiteSettings();

  const defaultTitle = s.site_title || "Fırat Construction Yapı A.Ş.";
  const template = s.title_template || `%s | ${s.company_short || "Fırat Construction"}`;
  const favicon = resolveImage(s.favicon_url || "");

  return (
    <Helmet defaultTitle={defaultTitle} titleTemplate={template}>
      {favicon ? <link rel="icon" type="image/x-icon" href={favicon} /> : null}
      {favicon ? <link rel="shortcut icon" href={favicon} /> : null}
      {favicon ? <link rel="apple-touch-icon" href={favicon} /> : null}
    </Helmet>
  );
};

export default SiteMeta;
